//
// locales/vanilla/is.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/is.json';
import localeData from 'react-intl/locale-data/is.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
